import { ErrorHandler, inject, Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { HttpErrorResponse, HttpStatusCode } from "@angular/common/http";

@Injectable({
	providedIn: "root",
})
export class GlobalErrorHandlerService implements ErrorHandler {
	readonly router = inject(Router);

	handleError(error: any): void {
		if (error instanceof HttpErrorResponse) {
			// Handle HTTP error
			if (error.status === HttpStatusCode.Unauthorized || error.status === HttpStatusCode.Forbidden) {
				// Redirect to the login page if the user is unauthorized or forbidden
				sessionStorage.clear();
				this.router.navigate(["/login"]);
			}
		} else {
			// Handle non-HTTP error (optional)
			console.error("An error occurred:", error);
		}
	}
}
